import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import compose from 'lodash.flowright';
import qs from 'query-string';
import classNames from 'classnames';

import { AlbumFolderWithCreatorBrandDetails } from '../../../../../graphql/queries/album-folder';
import OnboardingLayoutHeader from './components/OnboardingLayoutHeader';
import {
  getAlbumFolderOnboardingBackdropSrc,
  routeRequiresFlexibleHeight,
} from './helpers';
import useOpenModal from '../../../../../hooks/useOpenModal';
import MobileHeaderSupportButton from '../../../../../components/product/MobileHeaderSupportButton';
import { getAsset } from '../../../../../util/assets';

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  children: PropTypes.node.isRequired,
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};

const OnboardingLayout = ({ location, children, albumFolder }) => {
  const backdrop = getAlbumFolderOnboardingBackdropSrc(albumFolder);
  const openModal = useOpenModal();

  const layoutContentWrapClasses = classNames({
    'onboarding-layout-content-wrap': true,
    'flexible-height': routeRequiresFlexibleHeight(location.pathname),
  });

  return (
    <Fragment>
      <Helmet>
        <body className="body-onboarding" />
      </Helmet>

      <div className="onboarding-layout-wrap">
        {albumFolder && <OnboardingLayoutHeader albumFolder={albumFolder} />}
        <div className={layoutContentWrapClasses}>{children}</div>
      </div>

      <div className="onboarding-layout-backdrop">
        {backdrop ? (
          <img src={backdrop} alt={`Cover of ${albumFolder?.name}`} />
        ) : (
          <img src={getAsset('/onboarding-default-bg.jpg')} alt="" />
        )}
      </div>

      <MobileHeaderSupportButton
        className="onboarding-layout-help-bubble"
        openModal={openModal}
      />
    </Fragment>
  );
};

OnboardingLayout.propTypes = propTypes;

const withAlbumFolder = graphql(AlbumFolderWithCreatorBrandDetails, {
  options: ({ match, location }) => {
    const { albumFolderId } = qs.parse(location?.search);

    return {
      variables: {
        id: match.params.albumFolderId || albumFolderId,
      },
    };
  },
  props: ({ data: { albumFolder, loading } }) => ({
    loading,
    albumFolder,
  }),
  skip: ({ match, location }) => {
    const { albumFolderId } = qs.parse(location?.search);

    return !match.params.albumFolderId && !albumFolderId;
  },
});

export default compose(withRouter, withAlbumFolder)(OnboardingLayout);
